import { SearchFilters } from '../schemas'

export const getHierarchyDepth = (hierarchyItems: Array<string>) => {
  return hierarchyItems.filter((item) => item.length > 0).length
}

export function isPointSearch(filters: SearchFilters) {
  // Cause of design of area (GeoCircle), if we somewhere set within
  // it creates GeoCircle. If area has empty point it might mean we're look
  // after hierarchy (hierarchy + within)
  if (filters.area && !filters.area.isEmptyPoint) {
    return true
  }

  const hierarchyItems = filters.hierarchyPath
    ? filters.hierarchyPath.split('/')
    : []
  return getHierarchyDepth(hierarchyItems) === 4
}
